import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { WindowRef } from '../windowRef.service';

@Injectable()
export class SEADService {
  constructor(
    // tslint:disable-next-line: variable-name
    @Inject(DOCUMENT) private _document,
    public winRef: WindowRef
  ) { }

  private storage = window.sessionStorage;
  private optinKey = 'optins';

  private seadProducts = {
    LLC: 2,
    Inc: 1,
    NonProfit: 20,
    TM: 7,
    EPBundle: 149,
    LAP: 112,
    BAP: 109,
    DBA: 18,
  };

  public seadOptins = {
    // LLC specific
    // #for critical documents
    OA: 'operating-agreement',
    OA_EIN: 'operating-agreement-and-federal-taxid',
    OA_EIN_LICENCES: 'operating-agreement-federal-taxid-and-licenses',
    // end LLC specific ones
    // New
    BUSINESS_TAX_PLAN: 'affordable-tax',
    BUSINESS_LEGAL_PLAN: 'legal-protect',
    // end New
    WEB: 'web-domain',
    RA: 'registered-agent',
    EIN: 'federal-taxid',
    BAP: 'business-advantage-pro',
    BA: 'business-advantage',
    ACCOUNTING: 'accounting-help',
    BLP: 'business-license-package',
    BOFA: 'bofa-consultation',
    BUSINESS_CREDIT: 'business-credit-consult',
    PREP_501C3: '501c3-preparation',
    PERMIT_CA: 'sellers-permit-CA',
    PERMIT_TX: 'sellers-permit-TX',
    PERMIT_NJ: 'sellers-permit-NJ',
    PERMIT_OH: 'sellers-permit-OH',
    PERMIT_MI: 'sellers-permit-MI',
    PERMIT_CO: 'sellers-permit-CO',
    PERMIT_SC: 'sellers-permit-SC',
    PERMIT_VA: 'sellers-permit-VA',
    TAX_TX: 'state-tax-TX',
    TAX_NJ: 'state-tax-NJ',
    TAX_AZ: 'state-tax-AZ',
    TAX_CA: 'state-tax-CA',
    TAX_GA: 'state-tax-GA',
    TAX_PA: 'state-tax-PA',
    TAX_IL: 'state-tax-IL',
    TAX_WI: 'state-tax-WI',
    TAX_WA: 'state-tax-WA',
    TAX_FL: 'state-tax-FL',
    TAX_OH: 'state-tax-OH',
    TAX_MN: 'state-tax-MN',
    STATE_TAX: 'state-tax',
    STATEMENT_INFO: 'statement-information-CA',
    COMPLIANCE_FULL: 'compliance-full',
    COMPLIANCE_BASIC: 'compliance-basic',
    COMPLIANCE_CALENDAR: 'compliance-calendar',
    AMEX_BGR: 'amex-business-gold',
    AMEX_SIMPLY_CASH: 'amex-simply-cash',
    ADP: 'adp-service',
    TM_SEARCH_BASIC: 'trademark-search-basic',
    TM_SEARCH_FED_STATE: 'trademark-search-federal-state',
    TM_SEARCH_COMP_US: 'trademark-search-comprehensive-us',
    TM_SEARCH_INT_COMP: 'trademark-search-int-comprehensive',
    PAYMENT_PLAN_ANNUAL: 'payment-plan-annual',
    PAYMENT_PLAN_SEMI_ANNUAL: 'payment-plan-6-months',
    PRINTING_OPTION: 'printing-option',
    SHIPPING_STANDARD: 'standard-shipping',
    SHIPPING_OVERNIGHT: 'overnight-shipping',
    PRIORITY_PROCESSING: 'priority-processing',
    LOGO_SEARCH: 'federal-logo-search',
  };

  // promo_code mapped in Tealium with lzt_promocode
  public TrackingObject = {
    business_name: '',
    user_fname: '',
    user_lname: '',
    user_phone: '',
    first_entity: '',
    business_activity: '',
    installment_payment: '',
    pkgSelected: '',
  };
  public addOptin(optinName): void {
    const optins = this.optins;
    const itemIndex = optins.indexOf(optinName);
    if (itemIndex === -1) {
      optins.push(optinName);
      this.optins = optins;
    }
  }

  public removeOptin(optinName): void {
    const optins = this.optins;
    const itemIndex = optins.indexOf(optinName);
    if (itemIndex > -1) {
      optins.splice(itemIndex, 1);
      this.optins = optins;
    }
  }
  get optins() {
    return JSON.parse(this.storage.getItem(this.optinKey)) || [];
  }

  set optins(optins) {
    const nativeWin = this.winRef.nativeWindow;
    this.storage.setItem(this.optinKey, JSON.stringify(optins));
    const obj = {};
    obj[this.optinKey] = optins;
    nativeWin.utag.link(obj);
  }

  public DetectFields(): void {
    const seadFieldsList = this._document.querySelectorAll('*[data-sead]');
    seadFieldsList.forEach((seadField) => {
      const seadType = seadField.dataset instanceof DOMStringMap ? seadField.dataset.sead : seadField.getAttribute('data-sead');
      switch (seadType) {
        case 'first_llc':
        case 'installment_payment':
          seadField.addEventListener('change', () => {
            const val = seadField.value;
            this.TrackingObject[seadType] = val;
            this.PushToTealium();
          });
          break;
        default:
          seadField.addEventListener('blur', () => {
            const val = seadField.value;
            this.TrackingObject[seadType] = val;
            this.PushToTealium();
          });
          break;
      }
    });
  }

  public PushToTealium(): void {
    const nativeWin = this.winRef.nativeWindow;
    if (nativeWin.utag !== undefined) { nativeWin.utag.link(this.TrackingObject); } else {
      setTimeout(() => {
        if (nativeWin.utag !== undefined) { nativeWin.utag.link(this.TrackingObject); }
      }, 1000);
    }
  }
}
